<footer class="jadhu-footer">
  <div class="container">

    <div class="row g-4">

      <!-- Brand -->
      <div class="col-lg-4 col-md-12">

        <div class="jadhu-footer-brand">
          <span class="jadhu-footer-brand-wrapper">
            <img
              src="images/logo.png"
              alt="Jadhu Logo"
              class="jadhu-footer-brand-logo"
            >
          </span>
        </div>

        <p class="jadhu-footer-description">
          {{ footer.brandDescription }}
        </p>

        <!-- Social -->
        <div class="jadhu-footer-social">

          @if (footer.social.x) {
            <a
              [href]="footer.social.x"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X"
            >
              <i class="bi bi-twitter-x"></i>
            </a>
          }

          @if (footer.social.facebook) {
            <a
              [href]="footer.social.facebook"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i class="bi bi-facebook"></i>
            </a>
          }

          @if (footer.social.instagram) {
            <a
              [href]="footer.social.instagram"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i class="bi bi-instagram"></i>
            </a>
          }

          @if (footer.social.linkedin) {
            <a
              [href]="footer.social.linkedin"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <i class="bi bi-linkedin"></i>
            </a>
          }

        </div>

      </div>


      <!-- Quick Links -->
      <div class="col-lg-2 col-md-4 col-6">

        <h6 class="jadhu-footer-heading">
          Quick Links
        </h6>

        <a
          routerLink="/how-it-works"
          class="jadhu-footer-link"
        >
          How it works
        </a>

        <a
          routerLink="/roadmap"
          class="jadhu-footer-link"
        >
          Progress roadmap
        </a>

        <a
          routerLink="/pricing"
          class="jadhu-footer-link"
        >
          Pricing
        </a>

        <a
          routerLink="/science"
          class="jadhu-footer-link"
        >
          Science
        </a>

        <a
          routerLink="/for-clinics"
          class="jadhu-footer-link"
        >
          For clinics
        </a>

        <a
          routerLink="/faq"
          class="jadhu-footer-link"
        >
          FAQ
        </a>

      </div>


      <!-- Get In Touch -->
      <div class="col-lg-3 col-md-4 col-6">

        <h6 class="jadhu-footer-heading">
          Get in Touch
        </h6>

        <p class="jadhu-footer-label">
          Email
        </p>

        <a
          [href]="'mailto:' + footer.contact.email"
          class="jadhu-footer-link"
        >
          {{ footer.contact.email }}
        </a>

        <p class="jadhu-footer-label">
          Phone
        </p>

        <a
          [href]="footer.contact.phoneLink"
          class="jadhu-footer-link"
        >
          {{ footer.contact.phone }}
        </a>

        <p class="jadhu-footer-label">
          Support Hours
        </p>

        <span class="jadhu-footer-static-line">
          {{ footer.support.hours }}
        </span>

      </div>


      <!-- Company -->
      <div class="col-lg-3 col-md-4 col-12">

        <h6 class="jadhu-footer-heading">
          Company
        </h6>

        <p class="jadhu-footer-label">
          About
        </p>

        <span class="jadhu-footer-static-line">
          Empowering independence through technology, therapy, and real-world skill development.
        </span>

        <p class="jadhu-footer-label">
          Reach us
        </p>

        @if (footer.contact.whatsapp) {
          <a
            [href]="footer.contact.whatsapp"
            target="_blank"
            rel="noopener noreferrer"
            class="jadhu-footer-link"
          >
            WhatsApp community
          </a>
        }

        @if (footer.donation.milaap) {
          <a
            [href]="footer.donation.milaap"
            target="_blank"
            rel="noopener noreferrer"
            class="jadhu-footer-link"
          >
            Donate via Milaap · 80G
          </a>
        }

      </div>

    </div>


    <!-- Footer Bottom -->
    <div class="jadhu-footer-bottom">

      <span class="jadhu-footer-since">
        SINCE {{ footer.legal.sinceYear }}
      </span>

      <span class="jadhu-footer-legal">
        © {{ currentYear }} Jadhu ·
        <a routerLink="/privacy-policy">{{ footer.legal.privacy }}</a> ·
        <a routerLink="/terms-and-conditions"> {{ footer.legal.terms }}</a> ·
        {{ footer.legal.compliance }}
      </span>
    </div>


    <!-- Disclaimer -->
    <p class="jadhu-footer-disclaimer">
      {{ footer.disclaimer }}
    </p>

  </div>
</footer>
